import { Sparkles, Clock, Heart, Award } from "lucide-react";
import { IMAGES } from "@/data";

const STATS = [
  { icon: Sparkles, label: "Streak-free finish", value: "100%" },
  { icon: Clock, label: "On-time arrivals", value: "Always" },
  { icon: Heart, label: "Locally owned", value: "Family run" },
  { icon: Award, label: "Fully insured", value: "Guaranteed" },
];

export const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_rgb(0,0,0,0.12)]">
            <img src={IMAGES.familyPortrait} alt="The family behind ClearCo Window Cleaning" className="w-full h-[480px] object-cover object-center" />
          </div>
          <div className="absolute -bottom-6 -right-4 sm:right-6 bg-ink text-white rounded-2xl px-7 py-5 shadow-xl">
            <p className="font-display text-3xl font-extrabold text-brand">Family</p>
            <p className="text-sm text-slate-300">Owned & operated locally</p>
          </div>
        </div>

        <div>
          <p className="uppercase tracking-[0.2em] text-sm font-semibold text-brand">About ClearCo</p>
          <h2 className="mt-3 font-display font-bold text-4xl md:text-5xl tracking-tight text-slate-900">
            Family owned & operated
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            ClearCo is a family owned and operated window cleaning company proudly serving Castle Rock, Larkspur, Parker and the surrounding communities. When you hire us, you're supporting a local family — and we treat every home and business like it's our own.
          </p>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">
            From routine residential visits to large commercial jobs, gutters, and solar panels, our reliable, insured crew delivers spotless results and dependable service every single time.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-5">
            {STATS.map((s) => (
              <div key={s.label} data-testid={`about-stat-${s.label}`} className="rounded-xl border border-slate-200 p-5 transition-all duration-300 hover:border-brand/40 hover:-translate-y-1">
                <s.icon className="text-brand" strokeWidth={1.5} />
                <p className="mt-3 font-display font-bold text-xl text-slate-900">{s.value}</p>
                <p className="text-sm text-slate-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
